/**
 * Created by BETALOS on 14/07/2016.
 */
(function () {

    const angular = require('angular');


    const ConsultationContainerCtrl = require("./controllers/consultation-container/ConsultationContainerCtrl");
    const ConsultationBodyCtrl = require("./controllers/consultation-body/ConsultationBodyCtrl");
    const MobileConsultationCtrl = require("./controllers/mobile-consultation/MobileConsultationCtrl");
    const ObservationCtrl = require("./controllers/observation/ObservationCtrl");

    const mnConsultationBody = require("./components/consultation-body/consultation-body");

    const consultationService = require("./services/consultationService");

    angular
        .module("medinet")

        .controller('ConsultationContainerCtrl', ConsultationContainerCtrl)
        .controller('ConsultationBodyCtrl', ConsultationBodyCtrl)
        .controller('MobileConsultationCtrl', MobileConsultationCtrl)
        .controller('ObservationCtrl', ObservationCtrl)

        .component('mnConsultationBody', mnConsultationBody)

        .service("consultationService", consultationService);
})();